import { render, staticRenderFns } from "./changelog.vue?vue&type=template&id=3f2af0b2&"
import script from "./changelog.vue?vue&type=script&lang=js&"
export * from "./changelog.vue?vue&type=script&lang=js&"
import style0 from "./changelog.vue?vue&type=style&index=0&id=3f2af0b2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports